import createQueryStore from './createQueryStore';

const store = createQueryStore('customer');

export default store.reducer;
export const actions = store.actions;
export const useCustomerStore = store.useStore;
